<template>
  <div class="pc-tip">
    <div class="pc-tip__content">
      <!-- 图标 -->
      <div class="pc-tip__icon">
        <svg viewBox="0 0 64 64" width="76" height="76">
          <rect
            x="6"
            y="10"
            width="52"
            height="36"
            rx="4"
            fill="none"
            stroke="#409eff"
            stroke-width="3"
          />
          <line
            x1="24"
            y1="54"
            x2="40"
            y2="54"
            stroke="#409eff"
            stroke-width="3"
            stroke-linecap="round"
          />
          <line
            x1="32"
            y1="46"
            x2="32"
            y2="54"
            stroke="#409eff"
            stroke-width="3"
          />
        </svg>
      </div>

      <h2 class="pc-tip__title">请使用手机访问</h2>

      <p class="pc-tip__desc">
        检测到您正在使用电脑浏览器打开，<br />
        本页面仅支持移动设备浏览。
      </p>
      <p class="pc-tip__desc pc-tip__desc--sub">
        请使用手机扫描下方二维码，或直接在手机上打开链接。
      </p>

      <!-- 二维码（可选，传入 qrCode 才显示） -->
      <div v-if="qrCode" class="pc-tip__qr">
        <img :src="qrCode" alt="扫码访问" />
      </div>

      <!-- 当前地址 -->
      <p class="pc-tip__url">{{ url }}</p>

      <!-- 强制继续访问 -->
      <!-- <button
        v-if="showContinue"
        class="pc-tip__btn"
        @click="$emit('continue')"
      >
        仍要继续访问
      </button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "PcTip",
  props: {
    /** 二维码图片地址（可选） */
    qrCode: {
      type: String,
      default: "",
    },
    /** 是否显示「仍要继续访问」按钮 */
    showContinue: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.url = window.location.href;
  },
};
</script>

<style scoped>
.pc-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: #f5f7fa;
  background-image: radial-gradient(circle at 50% 0%, #e8f2ff 0%, #f5f7fa 60%);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.pc-tip__content {
  width: 100%;
  max-width: 460px;
  padding: 40px 28px;
  box-sizing: border-box;
  text-align: center;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.pc-tip__icon {
  margin-bottom: 16px;
  line-height: 0;
}

.pc-tip__title {
  margin: 0 0 16px;
  font-size: 22px;
  font-weight: 600;
  color: #303133;
}

.pc-tip__desc {
  margin: 0 0; /*: 8px;*/
  font-size: 14px;
  line-height: 1.8;
  color: #606266;
}

.pc-tip__desc--sub {
  margin-top: 8px;
  color: #909399;
}

.pc-tip__qr {
  width: 160px;
  height: 160px;
  margin: 20px auto 12px;
  padding: 8px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.pc-tip__qr img {
  display: block;
  width: 100%;
  height: 100%;
}

.pc-tip__url {
  margin: 12px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: #c0c4cc;
  word-break: break-all;
}

.pc-tip__btn {
  margin-top: 24px;
  padding: 10px 28px;
  font-size: 14px;
  color: #409eff;
  background: #fff;
  border: 1px solid #409eff;
  border-radius: 22px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.pc-tip__btn:hover {
  color: #fff;
  background: #409eff;
}
</style>
